import {
  COXAPOLKU_PAGE_NOTIFICATION,
  COXAPOLKU_SERVICES_NOTIFICATION,
} from '../../../definitions/NotificationConstants';
import { BACKENDNOTIFICATIONS } from '../../reducer';
import {
  notificationIsFetching,
  notificationShouldBeVisible,
} from '../selector';
import { doRequestDismissNotifications } from '../../notification/actions';
import Logger from '../../../utils/Logger';

const createActionName =
    require('../../util').createActionName('services/coxaPolku');

let { id: module_id } = module;
const logger = new Logger(module_id);

export const COXA_POLKU_REDIRECT_URL_RECEIVE = createActionName(
    'COXA_POLKU_REDIRECT_URL_RECEIVE'
);
export const COXA_POLKU_REDIRECT_URL_REQUEST = createActionName(
    'COXA_POLKU_REDIRECT_URL_REQUEST'
);
export const COXA_POLKU_REDIRECT_URL_ERROR = createActionName(
    'COXA_POLKU_REDIRECT_URL_ERROR'
);

export const requestRedirectUrl = () => ({
  type: COXA_POLKU_REDIRECT_URL_REQUEST,
});

export const receiveRedirectUrl = (data) => ({
  type: COXA_POLKU_REDIRECT_URL_RECEIVE,
  payload: data,
});

export const redirectUrlError = (data) => ({
  type: COXA_POLKU_REDIRECT_URL_ERROR,
  payload: data,
});

export const doRedirect = () => (dispatch, getState, services) => {
  dispatch(requestRedirectUrl());
  return services.api
      .coxaPolkuRedirect()
      .then((data) => {
        return dispatch(receiveRedirectUrl(data));
      })
      .catch((err) => {
        dispatch(redirectUrlError(err));
      });
};

export const automaticallyDismissCoxaPolkuActivationNotification =
    () => (dispatch, getState) => {
      let state = getState();
      let { data: notificationData } = state[BACKENDNOTIFICATIONS];

      if (
          notificationShouldBeVisible(COXAPOLKU_SERVICES_NOTIFICATION)(
              notificationData
          ) &&
          !notificationIsFetching(COXAPOLKU_PAGE_NOTIFICATION)(notificationData)
      ) {
        logger.debug('dispatching dismiss service activation notification');
        dispatch(
            doRequestDismissNotifications([COXAPOLKU_SERVICES_NOTIFICATION])
        );
      }
    };
